import {
  HiOutlineFolder,
  HiOutlineCheckCircle,
  HiOutlineUsers,
  HiOutlineUserPlus,
} from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { cn } from "../../../lib/cn";

const StatsCards = ({
  activeProjects = 0,
  totalProjects = 0,
  pendingTasks = 0,
  completedTasks = 0,
  network = 0,
  pendingConnections = 0,
  clients = 0,
  files = 0,
}) => {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Active Projects",
      value: activeProjects,
      subtitle: `${totalProjects} total`,
      icon: HiOutlineFolder,
      iconBg: "bg-secondary/10",
      iconColor: "text-secondary-dark",
      to: "/projects",
    },
    {
      title: "Pending Tasks",
      value: pendingTasks,
      subtitle: `${completedTasks} completed`,
      icon: HiOutlineCheckCircle,
      iconBg: "bg-warning/10",
      iconColor: "text-warning",
      to: "/tasks",
    },
    {
      title: "Network",
      value: network,
      icon: HiOutlineUsers,
      iconBg: "bg-success/10",
      iconColor: "text-success",
      to: "/network",
    },
    {
      title: "Pending Connections",
      value: pendingConnections,
      icon: HiOutlineUserPlus,
      iconBg: "bg-primary/5",
      iconColor: "text-primary",
      to: "/network/requests",
    },
    {
      title: "Active Clients",
      value: clients,
      icon: HiOutlineUsers,
      iconBg: "bg-primary/5",
      iconColor: "text-primary",
      to: "/network/clients",
    },
    {
      title: "Files",
      value: files,
      subtitle: "Across visible projects",
      icon: HiOutlineFolder,
      iconBg: "bg-secondary/10",
      iconColor: "text-secondary-dark",
      to: null,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
      {cards.map((card, idx) => {
        const Icon = card.icon;
        return (
          <div
            key={idx}
            onClick={() => card.to && navigate(card.to)}
            role={card.to ? "button" : undefined}
            tabIndex={card.to ? 0 : undefined}
            aria-label={card.title}
            onKeyDown={(e) => {
              if (card.to && e.key === "Enter") navigate(card.to);
            }}
            className={cn(
              "bg-white rounded-2xl p-6 shadow-sm border border-surface-border",
              card.to && "cursor-pointer hover:-translate-y-0.5 hover:shadow-lg",
              card.to && "focus-visible:ring-2 focus-visible:ring-secondary/60 focus-visible:outline-none",
              "transition-all duration-200"
            )}
          >
            <div className="flex items-start justify-between">
              <div>
                <h3 className="text-sm font-medium text-mediumgrey">
                  {card.title}
                </h3>
                <p className="text-3xl font-bold text-primary mt-2">
                  {card.value}
                </p>
                {card.subtitle && (
                  <p className="text-sm text-mediumgrey mt-1">
                    {card.subtitle}
                  </p>
                )}
              </div>
              <div className={cn("p-3 rounded-xl", card.iconBg, card.iconColor)}>
                <Icon className="w-6 h-6" />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
